// extracted by mini-css-extract-plugin
export default {"btn":"actions-button_btn__SrHDI","red":"actions-button_red__tzAEC"};